import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "新作", enum: "NEW" },
  { value: 2, text: "再販", enum: "RESALE" },
  { value: 3, text: "リピート", enum: "REPEAT" },
]);
